import { render, staticRenderFns } from "./agentPublishesNoticeDetails.vue?vue&type=template&id=abbd2194&scoped=true"
import script from "./agentPublishesNoticeDetails.vue?vue&type=script&lang=js"
export * from "./agentPublishesNoticeDetails.vue?vue&type=script&lang=js"
import style0 from "./agentPublishesNoticeDetails.vue?vue&type=style&index=0&id=abbd2194&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbd2194",
  null
  
)

export default component.exports